import z from "zod";

export const diagnosticEntryObjectiveAttributesSchema = z.object({
  id: z.string().nullable().optional(),
  does_not_need_estimate: z.boolean().nullable().optional(),
}).partial();

export const updateDiagnosticEntrySchema = z.object({
  technical_response: z.string().nullable().optional(),
  deadline_to_complete_in_days: z.string().nullable().optional(),
  objectives_attributes: z.array(diagnosticEntryObjectiveAttributesSchema).nullable().optional(),
}).partial();

export type UpdateDiagnosticEntryValidationSchema = z.infer<typeof updateDiagnosticEntrySchema>;
